import * as yup from 'yup';

export const initialValues = {
	sector: [],
	sectorOtherDescription: '',
};

const schema = 
	yup.object().shape({
		sector: yup.array().of(yup.string()).max(3, 'Selecione até 3 áreas de interesse'),
		sectorOtherDescription: yup.string().when('sector', {
			is: sector => sector.includes('Outro'),
			then: schema => schema.min(1, 'É obrigatório incluir uma descrição quando marcar "Outro"').required('É obrigatório incluir uma descrição quando marcar "Outro"'),
		}),
	});

export default schema;
